import React from 'react';
import ActionsContextV2 from '../ActionsContextV2';
import styled from 'styled-components';
import ActionsFunctionSelection from './ActionsFunctionSelection';
import {Select,MenuItem,FormControl,InputLabel,makeStyles,FormHelperText,Divider} from '@material-ui/core';
import ActionsProjectSearch from './ActionsProjectSearch';
const ProjectContainer = styled.div`
    display:flex;
    align-items:center;
    justify-content:space-between;
    width:100%;
    padding-left:30px;
    padding-right:30px;
    min-height:75px;
`

const Container = styled.div`
width:100%;
background-color:white;

`
const ProjectName = styled.div`
font-family: Roboto;
font-size: 24px;
font-weight: 500;
`
const ProjectSelect = styled.div`
`
const SelectContainer = styled.div`
    width:200px;
`;


const FunctionsContainer = styled.div`
    padding-left:20px;
    padding-right:20px;
    padding-bottom:4px;

`;

const ActionsProjectSearchContainer = styled.div`
    padding-left:20px;
    width:400px;
`;

const ProjectSearchContainer = styled.div `
    display:flex;
`


const useStyles = makeStyles((theme) => ({
    formControl: {
      margin: theme.spacing(1),
      minWidth: 120,
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
  }));

const ActionsProjectSelection = ( ) => {

    const context = React.useContext(ActionsContextV2);

    const projects = context.actionsRedux.projectFunctions;
    const classes = useStyles();
    let projectName = '';
    if(context.actionsRedux.selectedProject) {
        projectName = context.actionsRedux.selectedProject.preferredName ? context.actionsRedux.selectedProject.preferredName 
            : context.actionsRedux.selectedProject.name;
    }

    return (
        <Container>
            <ProjectContainer>
            
            <ProjectName>
                {/* {context.actionsRedux.selectedProject ? context.actionsRedux.selectedProject.name : ''} */}
                {projectName}
            </ProjectName>
            <ProjectSelect>
            {context.actionsRedux.projectFunctions.length > 1 &&
            <FormControl className={classes.formControl}>
               < ProjectSearchContainer>
                    <ActionsProjectSearchContainer>
                        <ActionsProjectSearch/>
                    </ActionsProjectSearchContainer>
                    </ProjectSearchContainer>

            </FormControl>
            }
            </ProjectSelect>
            </ProjectContainer>
            {context.actionsRedux.selectedProject && context.actionsRedux.selectedProject.functions.length > 1 &&
            <FunctionsContainer>
                <ActionsFunctionSelection/>
            </FunctionsContainer>
            }
            <Divider/>
        </Container>
    );
   

}

export default ActionsProjectSelection;